import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {AppStateService} from "../providers/app-state.service";
import {Order} from "../models/shop/order.model";
import {OrderService} from "../providers/order.service";

@Injectable()
export class OrderDetailResolve implements Resolve<Order> {
  constructor(private orderService: OrderService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Order> {
    this.appStateService.updateIsBusySubject(true);
    let paramMap = route.paramMap;
    if (paramMap.has('param')) {
      let param = paramMap.get('param');
      console.log(param)
      return this.orderService.getOrder(param).pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
    }


  }
}
